import React from 'react';
import { Loader2 } from 'lucide-react';
import { useRTL } from '../../contexts/RTLContext';
import { getTextAlignment } from '../../utils/rtl';

interface ToolCallIndicatorProps {
  toolName: string;
  state: 'input-streaming' | 'input-available' | 'output-available' | 'output-error' | string;
  args?: any;
}

// Utility function for className merging
function cn(...classes: (string | undefined | null | false)[]): string {
  return classes.filter(Boolean).join(' ')
}

export function ToolCallIndicator({ toolName, state, args }: ToolCallIndicatorProps) {
  const { isRTL } = useRTL()
  const textAlignment = getTextAlignment(isRTL)

  if (state === 'output-available') {
    return null; // Don't show anything when tool is complete
  }

  if (state === 'output-error') {
    return (
      <div className={cn("flex items-center gap-2 text-red-600 text-sm py-2", textAlignment)}>
        <span 
          style={{ direction: isRTL ? 'rtl' : 'ltr' }}
          dir={isRTL ? 'rtl' : 'ltr'}
        >
          Error running search tool
        </span>
      </div>
    );
  }

  return (
    <div className={cn("flex items-center gap-2 text-blue-600 text-sm py-2", textAlignment)}>
      <Loader2 className="h-4 w-4 animate-spin" />
      <span 
        style={{ direction: isRTL ? 'rtl' : 'ltr' }}
        dir={isRTL ? 'rtl' : 'ltr'}
      >
        Doing research on {args?.query ? `"${args.query}"` : 'this topic'}...
      </span>
    </div>
  );
} 